import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstVe3: [],
		ve3: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
	},
	getters: {
		
	},
	mutations: {
		set(state, ve3){
			state.ve3 = ve3
			if (ve3)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.ve3 = null
		},
		setParamsDataTable(state, payload){
			state.lstVe3 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async get(store, {ve3produto, ve3opcao, ve3tamanho}){
			return await this._vm.$axios.get(`/Representative/SalesForecastItems/Find?ve3produto=${ve3produto}&ve3opcao=${ve3opcao}&ve3tamanho=${ve3tamanho}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async find(store, ve3model){
			store.state.loading = true
			store.commit("initForm")
			await store.dispatch("get", ve3model)
			.then(ve3 => {
				store.commit("set", ve3)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		save(store){
			if (store.state.update){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/Representative/SalesForecastItems/Insert", store.state.ve3 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/previsoes-venda")
				store.state.ve3 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/Representative/SalesForecastItems/Update", store.state.ve3 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/previsoes-venda")
				store.state.ve3 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Representative/SalesForecastItems/Delete?ve3produto=${store.state.ve3.ve3produto}&ve3opcao=${store.state.ve3.ve3opcao}&ve3tamanho=${store.state.ve3.ve3tamanho}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/previsoes-venda")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async search(store, { limit = 20, page = 1 }){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get(`/Representative/SalesForecastItems/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
			})
			.catch((error) => {
				store.state.lstVe3 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		async createByCollectionAndOrFamily({ dispatch }, model){
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Gerando previsões de venda", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.post("/Representative/SalesForecastItems/CreateByCollectionAndOrFamily", model )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				return true
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async adjustByProduct(store, model){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Alterando previsões de venda", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.post("/Representative/SalesForecastItems/AdjustByProduct", model )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		}
	}
}